import { RootState } from 'common/redux/store';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useSelector } from 'react-redux';

dayjs.extend(utc);

export const useDateFormatter = () => {
  const {format } = useSelector(
     (state: RootState) => state.dateFormatter
   );

  const handleDateFormatting = (timeStamps: number | string) => {
    const result = timeStamps ?  dayjs.utc(timeStamps).format(format) : "-"
    return result;
  };

  return { handleDateFormatting };
};
